import React from 'react';
import { HERO_BUNDLE_IMAGE } from '../data/config';
import { BONUSES } from '../data/content';

// Shows the real bundle image when HERO_BUNDLE_IMAGE is set; otherwise a coded mockup.
export function BundleMockup({
  compact = false
}: {
  compact?: boolean;
}) {
  if (HERO_BUNDLE_IMAGE) {
    return <img src={HERO_BUNDLE_IMAGE} alt="150+ Done-For-You Coaching Sessions & Worksheets™ with 4 free bonuses" className={`mx-auto block h-auto w-full ${compact ? 'max-w-md' : 'max-w-xl'}`} data-id="element-193" data-mp="3clg9o9xb3j4i" />;
  }
  return <div className={`relative mx-auto w-full ${compact ? 'max-w-xs' : 'max-w-sm'} px-2 pb-4 pt-2`} data-id="element-194" data-mp="33muw6t6oyual">
      <div className="relative mx-auto w-[64%] rounded-2xl bg-white p-2 shadow-2xl" data-id="element-195" data-mp="2oq3qy3ac6od2">
        <div className="bg-sagegrad relative overflow-hidden rounded-xl p-3 text-white" data-id="element-196" data-mp="2tnvtrsciruw1">
          <p className="text-[9px] font-semibold tracking-[0.2em] text-white/80" data-id="element-197" data-mp="my7g6vvztijc">SIGMA SMART™</p>
          <p className="font-display mt-5 text-4xl font-extrabold leading-none text-terra" data-id="element-198" data-mp="rupkjunevev5">150+</p>
          <p className="font-display text-lg font-bold leading-tight" data-id="element-199" data-mp="qc9ekuyqcirb">DONE-FOR-YOU</p>
          <p className="font-display text-lg font-bold leading-tight" data-id="element-200" data-mp="ldfzwz7pilpk">COACHING SESSIONS</p>
          <p className="font-display text-lg font-bold leading-tight" data-id="element-201" data-mp="103n7ul038mc0">& WORKSHEETS™</p>
          <div className="mt-3 h-[6px] rounded bg-terra" data-id="element-202" data-mp="v3r3ulre4uwg" />
          <p className="mt-2 text-[9px] text-white/80" data-id="element-203" data-mp="v6dn3inn8yui">78 SESSIONS + 78 WORKSHEETS</p>
        </div>
      </div>
      <div className="mt-[-22px] grid grid-cols-4 gap-1.5" data-id="element-204" data-mp="7gjbt5iz3icd">
        {BONUSES.map((b, i) => <div key={b.title} className="min-w-0 rounded-lg bg-white p-1 shadow-md" style={{
        transform: `rotate(${[-4, -1, 2, 5][i]}deg)`
      }} data-id="element-205" data-mp="2hpt8yotx15c" data-mpi={i}>
            <div className="flex h-10 items-center justify-center rounded bg-sage font-display text-sm font-bold text-cream" data-id="element-206" data-mp="cdjhhfbwuj2y">B{i + 1}</div>
            <p className="mt-1 truncate text-center text-[7px] font-semibold" data-id="element-207" data-mp="1rsqdo57mi4qr">BONUS {i + 1}</p>
          </div>)}
      </div>
    </div>;
}

// Shows the real bonus cover when set; otherwise a coded cover.
export function BonusCover({
  index,
  image,
  short
}: {
  index: number;
  image: string;
  short: string;
}) {
  if (image) {
    return <img src={image} alt={`Bonus ${index + 1}`} className="mx-auto block h-auto w-full max-w-[180px]" loading="lazy" data-id="element-208" data-mp="ughuxj52jrpf" />;
  }
  return <div className="mx-auto w-full max-w-[150px] rounded-xl bg-white p-1.5 shadow-lg" data-id="element-209" data-mp="ygsczu64y8kn">
      <div className="bg-sagegrad flex aspect-[3/4] flex-col justify-between rounded-lg p-2.5 text-white" data-id="element-210" data-mp="1scakxhxg4q4">
        <p className="text-[8px] tracking-[0.18em] text-white/75" data-id="element-211" data-mp="6rp606mv6k4b">SIGMA SMART™</p>
        <div data-id="element-212" data-mp="arpkfr9yqvbd">
          <p className="font-display text-3xl font-extrabold leading-none text-terra" data-id="element-213" data-mp="ar6dt6prjtcn">B{index + 1}</p>
          <p className="font-display mt-1 text-sm font-bold leading-tight" data-id="element-214" data-mp="fjzglp1o8rm3">{short}</p>
        </div>
        <div className="h-[5px] rounded bg-terra" data-id="element-215" data-mp="3f5ecrmwm82d6" />
      </div>
    </div>;
}